import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import Icon from "../layout/icon"
import SmartLink from "../layout/SmartLink/SmartLink"

import {
  centeredContent as centeredContentStyle,
  container,
  filled,
  fullWidth as fullWidthStyle,
  icon,
  outline as outlineStyle,
} from "./styles.module.scss"

const ButtonLink = ({
  to,
  children,
  outline,
  clickEvent,
  noChevron,
  fullWidth,
  disabled,
  centeredContent,
  onDisabledClick,
  className,
}) => (
  <SmartLink
    to={to}
    clickEvent={clickEvent}
    disabled={disabled}
    onDisabledClick={onDisabledClick}
    noHoverStyle
  >
    <div
      className={classNames(
        container,
        {
          [filled]: !outline,
          [outlineStyle]: outline,
          [fullWidthStyle]: fullWidth,
          [centeredContentStyle]: centeredContent,
        },
        className,
      )}
    >
      {children}
      {!noChevron && (
        <Icon icon={faChevronRight} className={classNames(icon)} />
      )}
    </div>
  </SmartLink>
)

ButtonLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  outline: PropTypes.bool,
  clickEvent: PropTypes.shape({
    name: PropTypes.string,
    properties: PropTypes.object,
  }),
  noChevron: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  centeredContent: PropTypes.bool,
  onDisabledClick: PropTypes.func,
  className: PropTypes.string,
}

ButtonLink.defaultProps = {
  outline: false,
  clickEvent: undefined,
  noChevron: false,
  fullWidth: false,
  disabled: false,
  centeredContent: false,
  onDisabledClick: () => {},
  className: undefined,
}

export default ButtonLink
